import {
    ContentfulEntryContract,
    ContentfulEntryContractFields,
    ContentfulEntryFromContract,
} from './contracts';

export interface CheckInMessageContentFields
    extends ContentfulEntryContractFields {
    title?: string;
    name?: string;
    html?: string;
}

export type CheckInMessageContract = ContentfulEntryContract<
    CheckInMessageContentFields,
    'checkInMessage'
>;

export type CheckInMessageContent =
    ContentfulEntryFromContract<CheckInMessageContract>;

export class CheckInMessage {
    private contract: CheckInMessageContent;

    constructor(contract: CheckInMessageContent = {} as CheckInMessageContent) {
        this.contract = contract;
    }

    get html(): string {
        return this.contract.fields.html ?? '';
    }

    get name(): string {
        return this.contract.fields.name ?? '';
    }

    get title(): string {
        return this.contract.fields.title ?? '';
    }
}
